import { v4 as uuid } from 'uuid';
export default {
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      "default": function _default() {
        return "text-input-".concat(uuid());
      }
    },
    type: {
      type: String,
      "default": 'text'
    },
    error: String,
    label: String,
    modelValue: String
  },
  emits: ['update:modelValue'],
  methods: {
    focus: function focus() {
      this.$refs.input.focus();
    },
    select: function select() {
      this.$refs.input.select();
    },
    setSelectionRange: function setSelectionRange(start, end) {
      this.$refs.input.setSelectionRange(start, end);
    }
  }
};